import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import {
    ACTION_BUTTONS_DESCRIPTION_PROVIDER,
    appConfig,
    ComponentsModule,
    CULTURE_CONFIG,
    FuseConfigModule,
    FuseModule,
    LayoutModule,
    MENU_HEADER_CONFIGURATION,
    MenuHeaderConfiguration,
    NAVIGATION_CONF,
    StartupModule,
    TAB_SERVICE_PROVIDER
} from '@fidcare/base-gui';
import {
    AUTHENTICATION_CONFIG,
    CART_SERVICE_BASE_PATH,
    CULTURE_CONFIG as CORE_CULTURE_CONFIG,
    DirectiveUtils,
    JwtInterceptor,
    PROJECT_VERSION,
    RESOURCE_CONTROL_SERVICE_BASE_PATH,
    SERVICE_BASE_PATH,
    StartupModule as CoreStartupModule
} from '@fidcare/fe-core';
import { BASE_PATH as DDL_BASE_PATH, DDLService } from '@fidcare/ddl-api';
import { BASE_PATH as HFM_BASE_PATH, HfmService, StruttureService } from '@fidcare/hfm-api';
import { BASE_PATH as HOP_BASE_PATH, ButtonService, TabsService } from '@fidcare/hop-api';
import { BASE_PATH as PAS_12_BASE_PATH, UtenteService } from '@fidcare/pas-api';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { environment } from 'environments/environment';
import { MarkdownModule } from 'ngx-markdown';
import packageInfo from '../../package.json';
import { ActionButtonProvider } from './hop-module/services/action-buttons.providel.component';
import { navigation } from './navigation';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
};

var menuConf: MenuHeaderConfiguration = {
	agendaButtonConfiguration: { enabled: false },
	profileButtonConfiguration: {enabled: true, routerLink: "/profile"},
	notificationButtonConfiguration: {enabled: false},
	quickmenuButtonConfiguration: { enabled: false }
}
export let AppInjector: Injector;

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ComponentsModule.forRoot(environment.forms),
        RouterModule.forRoot(appRoutes, routerConfig),
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        // Core module of your application
        StartupModule.forRoot(environment.culture),
        CoreStartupModule.forRoot(environment.culture),

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({})
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
		ButtonService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: AUTHENTICATION_CONFIG, useValue: environment.authentication },
        { provide: CULTURE_CONFIG, useValue: environment.culture },
        { provide: CORE_CULTURE_CONFIG, useValue: environment.culture },
        { provide: SERVICE_BASE_PATH, useValue: environment.services.api.serviceBasePath },
		{ provide: PAS_12_BASE_PATH, useValue: environment.services.api.pasBasePath },
		{ provide: NAVIGATION_CONF, useValue: navigation},
		{ provide: TAB_SERVICE_PROVIDER, useClass: TabsService },
		{ provide: MENU_HEADER_CONFIGURATION, useValue: menuConf},
		{ provide: DDL_BASE_PATH, useValue: environment.services.api.ddlBasePath },
        { provide: HOP_BASE_PATH, useValue: environment.services.api.hopBasePath },
		{ provide: ACTION_BUTTONS_DESCRIPTION_PROVIDER, useClass: ActionButtonProvider},
        { provide: PROJECT_VERSION, useValue: packageInfo.version},
        { provide: CART_SERVICE_BASE_PATH, useValue: environment.services.api.ddlBasePath },
        { provide: RESOURCE_CONTROL_SERVICE_BASE_PATH, useValue: environment.services.api.rcsBasePath },
        { provide: HFM_BASE_PATH, useValue: environment.services.api.hfmBasePath },

        
        StruttureService,
        DDLService,
        TabsService,
        DirectiveUtils,
        UtenteService
    ]
})
export class AppModule {
	constructor(private injector: Injector) {
		AppInjector = this.injector;
	}	
}
